import { keyframes } from '@emotion/react';
import { Tooltip, tooltipClasses } from '@mui/material';
import SvgClose from 'assets/general/close.inline.svg';
import React, { useEffect, useState } from 'react';
import tw, { css, styled } from 'twin.macro';

const greenToTransparent = keyframes`
  from {
    background-color: var(--color-green-3);
  }
  to {
    background-color: var(--color-transparent);
  }
`;

const cssBackground = ({ isBgCovered }) => css`
	${tw`absolute left-0 top-0 w-full h-full bg-green-3`}
	
	${!isBgCovered && css`
		animation: ${greenToTransparent} 0.25s 0.3s forwards;
	`}
`;

const HtmlTooltip = styled(({ className, children, ...props }) => (
	<Tooltip {...props} classes={{ popper: className }}>
		{children}
	</Tooltip>
))(({ theme }) => ({
	[`& .${tooltipClasses.tooltip}`]: {
		border: '4px solid #0E773F',
		maxWidth: 450,
		borderRadius: 0,
		padding: 0
	},
}));

export default function TooltipCode({ Content, children, clearSpan, ...props }) {
	const [showTooltip, setShowTooltip] = useState(false);
	const [isBgCovered, setBgCovered] = useState(false);

	useEffect(() => {
		setBgCovered(!showTooltip);
	}, [showTooltip]);

	const handleOpenTooltip = () => {
		setShowTooltip(true);
	};

	const handleCloseTooltip = () => {
		setBgCovered(true);
		setShowTooltip(false);
	};

	if(!Content) return null;

	return (
		<HtmlTooltip
			open={showTooltip}
			onOpen={handleOpenTooltip}
			onClose={handleCloseTooltip}
			disableTouchListener
			title={
				<div>
					<div className='flex items-center justify-end bg-green-2'>
						<div className='mb-02 bg-light cursor-pointer'>
							<SvgClose onClick={handleCloseTooltip} />
						</div>
					</div>
					<div className='relative text-08 leading-12 text-light font-light bg-green-3 p-10'>
						<div css={[ cssBackground({ isBgCovered }) ]} />
						{Content}
					</div>
				</div>
			}
			{...props}
		>
			<span className={clearSpan ? 'pointer' : 'pointer flex items-center mx-03'} onClick={() => setShowTooltip(prev => !prev)}>{children}</span>
		</HtmlTooltip>
	);
}

TooltipCode.defaultProps = {
	placement: 'top',
};
